export default "__VITE_ASSET__B1i8mDDn__"